export default __webpack_public_path__ + "static/media/word.9ea2aff0.svg";